import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { SnackbarProvider } from "notistack";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { getEnvVariable } from "helpers/commonFunctions";

function App() {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={getEnvVariable("REACT_APP_RECAPCHA_KEY")}
      scriptProps={{ async: true }}
    >
      <SnackbarProvider
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        maxSnack={4}
      >
        <RouterProvider router={router} />
      </SnackbarProvider>
    </GoogleReCaptchaProvider>
  );
}

export default App;
